import React from "react";

// Pasek z logotypami Funduszy Europejskich (zgodny z zasadami oznakowania FE dla Śląskiego 2021–2027)
export const EuLogoBar = () => (
  <div className="w-full bg-white border-b border-slate-100" data-testid="eu-logo-bar">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex justify-center">
      <img
        src="/eu-logos.webp"
        alt="Logotypy: Fundusze Europejskie dla Śląskiego, Rzeczpospolita Polska, Dofinansowane przez Unię Europejską, Województwo Śląskie"
        className="w-full max-w-3xl h-auto object-contain"
      />
    </div>
  </div>
);

export default EuLogoBar;
